export default function PHP_fetch_array() {
  return (
    <div>
      <h1>PHP_fetch_array</h1>
    </div>
  );
}
